import React from 'react';

import StatsWrapper from 'components/Stats/StatsWrapper';
import NavPills from "components/NavPills/NavPills.jsx";
import PricingTable from './GeneralTabs/PricingTable';
import TotalsByReferenceTable from './GeneralTabs/TotalsByReferenceTable';
import TotalsByServiceTable from './GeneralTabs/TotalsByServiceTable';

export default class GeneralTab extends React.Component {
    render() {

        const id = this.props.customer_id + "-" + this.props.product_id;

        return (
            <NavPills
                swipeableSlideStyles={{ padding: 20 }}
                tabsStyles={{ marginTop: 0 }}
                color="warning"
                tabs={[
                    {
                        tabButton: "Totals by Reference",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="accountProductTotalsByReference" post params={{ customer_id: (typeof this.props.customer_id === "string" ? parseInt(this.props.customer_id) : this.props.customer_id), product_id: (typeof this.props.product_id === "string" ? parseInt(this.props.product_id) : this.props.product_id) }}>
                                <TotalsByReferenceTable />
                            </StatsWrapper>
                        )
                    },
                    {
                        tabButton: "Totals by Service",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="accountProductTotalsByService" post params={{ customer_id: (typeof this.props.customer_id === "string" ? parseInt(this.props.customer_id) : this.props.customer_id), product_id: (typeof this.props.product_id === "string" ? parseInt(this.props.product_id) : this.props.product_id) }}>
                                <TotalsByServiceTable />
                            </StatsWrapper>
                        )
                    },
                    {
                        tabButton: "Current Pricing",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="priceForProduct" post params={{ customer_id: (typeof this.props.customer_id === "string" ? parseInt(this.props.customer_id) : this.props.customer_id), product_id: (typeof this.props.product_id === "string" ? parseInt(this.props.product_id) : this.props.product_id) }} hideDatePicker>
                                <PricingTable />
                            </StatsWrapper>
                        )
                    }
                ]}
            />
        );
    }
}
